var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mqtt-charts"},[_c('BaseChartWrapper',{attrs:{"chart-data":_vm.tempValve}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }